import Select from "react-select";

export default function CustomSelectBox(props) {
  const { options, isDisabled, customStyleProps = {}, ...rest } = props;

  const {
    width = "100%",
    height,
    borderRadius = "9999px",
    border = "1px solid #00AEEF",
    padding = "2px 6px",
    boxShadow = "none",
    arrowColor = "#00AEEF",
    showPipe = true,
  } = customStyleProps;

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      width: width,
      height: height,
      borderRadius: borderRadius,
      border: state.isFocused ? "2px solid #00AEEF" : border,
      padding: padding,
      boxShadow:
        state.isFocused && boxShadow === "none"
          ? "0 0 0 2px rgba(0,174,239,0.3)"
          : boxShadow,
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#666",
      fontWeight: "500",
    }),
    dropdownIndicator: (provided, state) => ({
      ...provided,
      color: arrowColor ? arrowColor : "#00AEEF",
      transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : null,
      transition: "transform 0.2s ease",
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: "12px",
      marginTop: "8px",
      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
      zIndex: 10,
    }),
    option: (provided, state) => {
      const isHeading = state.isDisabled;
      return {
        ...provided,
        borderRadius: isHeading ? 0 : "8px",
        backgroundColor: isHeading
          ? "#F3F6F9"
          : state.isSelected
          ? "#00AEEF"
          : state.isFocused
          ? "#E6F7FC"
          : "white",
        color: state.isSelected ? "white" : "#333",
        padding: "10px 15px",
        cursor: "pointer",
        fontWeight: isHeading ? "700" : "normal",
      };
    },
    indicatorSeparator: () => ({
      display: showPipe ? "block" : "none", // remove pipe
    }),
  };

  return (
    <div style={{ width }}>
      <Select
        options={options}
        placeholder="Select"
        styles={customStyles}
        isSearchable={true}
        {...rest}
        isDisabled={isDisabled}
      />
    </div>
  );
}
